import React from "react";

export const ConsumerConsentData = () => {
  return (
      <div>
        <p>By using this portal, you have opted to conduct the application process electronically. Below are two important application disclosures:</p>
        <p style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '24px',
          fontWeight: 'bold',
        }}>
          OUR USE OF CREDIT REPORTS AND OTHER CONSUMER INFORMATION</p>
        <p>In connection with this application for insurance, we may review your credit report from a credit reporting agency, or obtain or use a credit-based insurance score based on information contained in the credit report. We use credit information to determine the rating used to develop premium.</p>
        <p>An insurance score uses information from your credit report to help predict how often you are likely to file claims and how expensive those claims will be. Typical items from a credit report that could affect a score include, but are not limited to, the following: payment history, number of revolving accounts, number of new accounts, and the presence of collection accounts, bankruptcies and foreclosures where permitted by law.</p>
        <p>We use a third-party, Lexis-Nexis, in connection with the development of your insurance score.</p>
        <p>You have the right to request, in writing, that we consider an extraordinary life circumstance in considering your credit information. An extraordinary life circumstance means:</p>
        <ul>
          <li>Catastrophic illness or injury,</li>
          <li>Divorce,</li>
          <li>The death of a spouse, child or parent,</li>
          <li>The involuntary loss of employment for more than 3 consecutive months,</li>
          <li>Identity theft,</li>
          <li>Total or other loss that makes a home uninhabitable, or</li>
          <li>Any other circumstances we may choose to recognize</li>
        </ul>
        <p>Our decision to request a credit report will not be made based on your race, color, creed, martial status, sex or national origin.</p>
        <p>If you are affected by an adverse underwriting decision based on our review of a credit report, we will advise you as required by law and will advise where you may obtain a copy of the credit report.</p>
        <p>We also review Motor Vehicle Reports (MVRs) provided by state vehicle agencies and CLUE reports, provided by LexisNexis, in determining the rating used to develop premium.</p>
        <p style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '24px',
          fontWeight: 'bold',
        }}>
          FRAUD WARNING</p>
        <p style={{
          fontWeight: 'bold',
        }}>
          Any Person who makes an application or files a claim with intent to defraud or help commit a fraud against an insurer is guilty of a crime.</p>
      </div>
  );
};
